import './MenuIcon.scss';
import PropType from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';

export default function MenuIcon({icon, label, dropDownIcon, disabled, children, onClick}) {
  const opacity = disabled ? 0.6 : 1;
  const color = `rgba(255, 255, 255, ${opacity})`;

  const handleClick = disabled ? () => {} : onClick;

  return (
    <div
      className={`fast-menu-icon ${disabled ? 'fast-menu-icon-disabled' : ''}`}
      onClick={handleClick}
      role="presentation"
    >
      <div className="fast-menu-icon__icon">
        <FmlxIcon name={icon} customColor={color} size="sm" />
      </div>
      <div className="fast-menu-icon__label">
        {label}
        {dropDownIcon ? <FmlxIcon name="ArrowDownS" customColor={color} size="xs" /> : ''}
      </div>
      {children}
    </div>
  );
}

MenuIcon.propTypes = {
  icon: PropType.string,
  label: PropType.string,
  dropDownIcon: PropType.bool,
  disabled: PropType.bool,
  children: PropType.node,
  onClick: PropType.func,
};

MenuIcon.defaultProps = {
  icon: '',
  label: 'Title',
  dropDownIcon: false,
  disabled: false,
  children: null,
  onClick: () => {},
};
